import { useEffect } from 'react';

export const useBroadcastAuthSubscriber = () => {
  useEffect(() => {
    const channel = new BroadcastChannel('auth-state');
    channel.onmessage = function (event) {
      if (event?.data?.type === 'AUTH_CHANGED') {
        window.location.href = '/';
        return;
      }
      window.location.reload();
    };
    return () => channel.close();
  }, []);
};

export const broadcastAuthChange = () => {
  const channel = new BroadcastChannel('auth-state');
  channel.postMessage({ type: 'AUTH_CHANGED' });
  channel.close();
};

export const broadcastUserLogin = () => {
  const channel = new BroadcastChannel('auth-state');
  channel.postMessage({ type: 'USER_LOGGED_IN' });
  channel.close();
};
